<template>
<div></div>
</template>

<script>
export default {
    methods: {
        isAuthenticated() {
            this.$auth.isAuthenticatedAPI().then(isAuthenticated => {
                this.$router.push({
                    name: isAuthenticated ? "Home" : "Login"
                })

            });
        }
    },
    async mounted() {
        await this.isAuthenticated();
    }
};
</script>
